export enum PointsRewardsListMessages {
  REWARD_ICON = 'mg-points-menu',
  REDEEM_BUTTON = 'Redeem',
}
